import React, { useState } from "react";
import {
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import CopyIconButton from "components/atoms/CopyIconButton";
import { TabProps } from "../../../../SourceModal.types";
import BaseOverview from "./BaseOverview";

const CapiOverview: React.FC<TabProps> = ({ tracker, language }) => {
    const [tokenAreaVisible, setTokenAreaVisible] = useState(true);
    const alias = tracker?.tracker?.alias;

    return (
        <BaseOverview language={language}>
            <div>
                <h1 className="mb-3">Offline Events</h1>
                {alias && (
                    <div className="bearer-token-area">
                        <span className="bearer-token-title">
                            {language?.tracker_detail?.overview
                                ?.bearer_token_title ??
                                "Authorization Token is (bearerAuth)"}
                            <a
                                href="javascript:;"
                                onClick={() =>
                                    setTokenAreaVisible(!tokenAreaVisible)
                                }
                            >
                                {!tokenAreaVisible ? (
                                    <VisibilityIcon />
                                ) : (
                                    <VisibilityOffIcon />
                                )}
                            </a>
                        </span>
                        <div className="bearer-token-blockquote">
                            {tokenAreaVisible ? (
                                <div className="blur-area">
                                    <span>{alias}</span>
                                </div>
                            ) : (
                                <span>{alias}</span>
                            )}
                            <CopyIconButton value={alias || ""} />
                        </div>
                    </div>
                )}

                <p>
                    {language?.tracker_detail?.overview?.capi_msg ??
                        "Capture and upload offline customer interactions, such as in-store purchases or call center data. This source helps bridge the gap between online and offline data. By integrating offline events, you can create a unified view of customer journeys. It also allows you to measure the full impact of your marketing efforts across all touchpoints."}
                </p>
            </div>
        </BaseOverview>
    );
};

export default CapiOverview;
